import service from './../service.js';

export default {
    all() {
        return service.get('/reference/branches');
    }
}